import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {PhoneHQToast} from "ch3-ui-lib";
import {getToast, hideToast} from "../../store/features/Notifications/notificationsSlice";
import {matrixService} from "../../services/matrixService.ts";

const ToastNotification = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const timeoutRef = useRef<number | null>(null)

    const {
        title,
        description,
        isOpen,
        type,
        position,
        dontHide,
        icon,
        navigateToRoom,
        navigateToPath
    } = useSelector(getToast);

    const timeout = dontHide ? 24*60*60*1000 : 3000;

    const handleSetOpen = (open: boolean) => {
        if (!open) {
            dispatch(hideToast());
        }
    };

    const handleToastClick = () => {
        if (navigateToRoom) {
            navigate('/chat');
            matrixService.selectRoom(navigateToRoom);
        } else if (navigateToPath) {
            navigate(navigateToPath);
        }

        dispatch(hideToast());
    };

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (isOpen) {
            timeoutRef.current = setTimeout(() => {
                dispatch(hideToast());
            }, timeout);
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [isOpen, timeout, dispatch]);

    const isClickable = Boolean(navigateToRoom || navigateToPath);

    return createPortal(
        <div className='toast-layer'>
            <PhoneHQToast
                title={title}
                description={description}
                type={type}
                open={isOpen}
                onOpenChange={handleSetOpen}
                icon={icon}
                position={position}
                onClick={isClickable ? handleToastClick : undefined}
            />
        </div>,
        document.body,
    );
};

export default ToastNotification;